// extracted by mini-css-extract-plugin
export default {"container":"style__container___a449n","title":"style__title___u7cM3","inner":"style__inner___OVd7I"};